import React, { memo, useState, useEffect, useMemo } from "react";
import { array, object, string, func } from "prop-types";

import style from "./style.module.scss";
import CompareOverview from "./CompareOverview";
import CompareLabelTable from "./CompareLabelTable";
import { getComparisons, isComparisonReady } from "./utils";

export default memo(CompareSection);

CompareSection.propTypes = {
  history: object,
  histories: array,
  selectedLabelId: string,
  onSelectLabel: func,
  onViewHistory: func,
};

function CompareSection({
  history,
  histories,
  selectedLabelId,
  onSelectLabel,
  onViewHistory,
}) {
  const comparisons = useMemo(() => getComparisons(history), [history]);
  const readyComparisons = useMemo(
    () => comparisons.filter(isComparisonReady),
    [comparisons]
  );

  // Default to the first comparison (groundTruthId has priority)
  const [activeKey, setActiveKey] = useState("");
  // Only comparisons with per-label rows can be shown in the table
  const tableComparisons = useMemo(
    () =>
      readyComparisons.filter(
        (comparison) => comparison.result?.labelTypes?.length > 0
      ),
    [readyComparisons]
  );

  // Keep the user's toggle choice while it is still available
  useEffect(() => {
    setActiveKey((prev) =>
      tableComparisons.some((comparison) => comparison.key === prev)
        ? prev
        : tableComparisons[0]?.key || ""
    );
  }, [tableComparisons]);

  // Switching to another history resets to the default (groundTruthId first)
  useEffect(() => {
    setActiveKey(tableComparisons[0]?.key || "");
  }, [history?.historyId]);

  if (!comparisons.length) return null;

  return (
    <div className={style.compareCard}>
      <div className={style.compareHeader}>
        <span className={style.compareTitle}>Kết quả so sánh</span>
        <span className={style.compareHint}>% theo diện tích</span>
      </div>

      <CompareOverview
        comparisons={comparisons}
        histories={histories}
        activeKey={tableComparisons.length > 1 ? activeKey : ""}
        selectableKeys={
          tableComparisons.length > 1
            ? tableComparisons.map((comparison) => comparison.key)
            : []
        }
        onSelect={setActiveKey}
        onViewHistory={onViewHistory}
      />

      {tableComparisons.length > 0 && (
        <CompareLabelTable
          key={history.historyId}
          comparisons={tableComparisons}
          activeKey={activeKey}
          selectedLabelId={selectedLabelId}
          onSelectLabel={onSelectLabel}
        />
      )}
    </div>
  );
}
